import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAcYRHHWiAe3rfYDk6srna5nbL9lBlUxIY",
  authDomain: "b7thspace-7c94e.firebaseapp.com",
  projectId: "b7thspace-7c94e",
  storageBucket: "b7thspace-7c94e.appspot.com",
  messagingSenderId: "876046797370",
  appId: "1:876046797370:web:839c8aca4e0cc5e1460303",
  measurementId: "G-KCWS7NNF4C"

};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
